import * as React from 'react';
import { RelatedContent } from '../RelatedContent';
import { MixesIn } from './MixesIn';

export const AdditionalInfo = ({ data }) => {
  const hasInheritsFrom = data.mixes && data.mixes.length > 0;
  return (
    <>
      {hasInheritsFrom && <MixesIn items={data.mixes} />}
      <RelatedContent relatedContent={data.relatedContent} />
    </>
  );
};
